module.exports = __webpack_public_path__ + "static/media/work3.7d0de691.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work3.png
// module id = 84
// module chunks = 0